import { render, staticRenderFns } from "./BusinessPlatform.vue?vue&type=template&id=fddd4e1a&scoped=true&"
import script from "./BusinessPlatform.vue?vue&type=script&lang=js&"
export * from "./BusinessPlatform.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPlatform.vue?vue&type=style&index=0&id=fddd4e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddd4e1a",
  null
  
)

export default component.exports